import MatchingCardFront from "../../assets/GameAssets/MatchingGame/MatchingCardFront.png";
import React, { forwardRef , createRef } from "react";
import MatchingGameStarNight_Neon_Back from "../../assets/GameAssets/MatchingGame/MatchingGameStarNight_Neon_Back.png";

const MatchingGameCard = forwardRef(
  ({ item, handleClick, id, size = "medium", cardBack, theme }, cardRef) => {
  const sizeStyles =
    size === "large"
      ? { width: "100px", height: "160px" }//height --> 140px
      : size === "medium"
      ? { width: "80px", height: "130px" }//height --> 110px
      : { width: "60px", height: "110px" };//height --> 90px

  const isFlipped = item.stat === "active" || item.stat === "correct";

  return (
    <div
  // className={`card-mg`} // remove ${item.stat} here
    className={`card-mg ${item.stat === "correct" ? "card-correct" : ""}`}
      ref={cardRef}                
      onClick={() => handleClick(id, cardRef.current)}
      style={{
      width: "100px",
      height: "100px",
      margin: "10px",
      perspective: "1000px",
      cursor: item.stat === "correct" ? "default" : "pointer",
  }}
    >
      <div
        className="card-inner"
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          transition: "transform 0.6s",
          transformStyle: "preserve-3d",
          transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
        }}
      >
        {/* Front Side --> symbol*/}
        <div
          className="card-front"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backfaceVisibility: "hidden",
            borderRadius: "8px",
            boxShadow: "0 0 8px rgba(0,0,0,0.2)",
            backgroundImage: `url(${cardBack})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        {/* Back Side --> answers*/}
        <div
          className="card-back"
          style={{
            position: "absolute",
            width: "100%",
            outline: "none",
            height: "100%",
            backfaceVisibility: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "24px",
            fontWeight: "bold",
            boxShadow: "0 0 8px rgba(0,0,0,0.2)",
            color: theme === "highrise" ? "#ff45c7ff" : "#000000ff", // pink for highrise, black for others
            backgroundImage: `url(${theme === "highrise" ? MatchingGameStarNight_Neon_Back : MatchingCardFront})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            border: "none",
            transform: "rotateY(180deg)",
            fontFamily: "Quicksand , sans-serif",
            }}
          >
            {item.text}
          </div>
        </div>
      </div>
    );
  }
);

export default MatchingGameCard;
